import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServiceHelpers {

  getCommonHeaders() {
    const httpOptions = {
      // withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return httpOptions;
  }

  getTextHeaders() {
    const httpOptions = {
      
      headers: new HttpHeaders(
        {
          'Accept': 'text/html, application/xhtml+xml, */*',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      )
    };
    return httpOptions;
  }

  getUpdateHeaders() {
    const httpOptions = {
      // withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Action-Type': 'update'
      })
    };
    return httpOptions;
  }

  getCreateHeaders() {
    const httpOptions = {
      // withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Action-Type': 'create'
      })
    };
    return httpOptions;
  }

  getDeleteHeaders() {
    const httpOptions = {
      // withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Action-Type': 'delete'
      })
    };
    return httpOptions;
  }

  handleErrors(error: Response) {
    console.log(error);
    return error;
  }

  handleObservableError(error: any): Observable<any> {
    console.log(error);
    return throwError(error.message || error);
  }

  handlePromiseError(error: any): Promise<any> {
    console.log(error);
    return Promise.reject(error.message || error);
  }

  extractData(res: Response) {
    const body = res.json();
    const data = body;
    return data || {};
  }
}
